// extracted by mini-css-extract-plugin
module.exports = {"bgprimary":"#242324","bgsecondary":"#2c2b2c","primary":"#13a57c","secondary":"#5398be","tertiary":"#fbc34c","marker":"#fff","markerActive":"#13a57c","markerHighlighted":"#fff"};